import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Heart, Shield, CheckCircle, Clock, Users } from 'lucide-react';

export default function ForCaregiversPage() {
  return (
    <div className="min-h-screen py-24 md:py-32 bg-background" data-testid="for-caregivers-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-medium tracking-wider uppercase text-accent mb-3 block">Pour les aidants</span>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Vous méritez aussi de souffler
          </h1>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            M-CareLink coordonne des séjours de répit adaptés pour que vous puissiez partir en vacances avec votre proche, sereinement.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 border border-border/30 shadow-sm mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-6">Nous comprenons votre quotidien</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-muted-foreground leading-relaxed">
            <p>Accompagner un proche au quotidien est un engagement profond qui peut générer une fatigue physique et mentale considérable. Le besoin de répit est légitime et essentiel pour préserver votre santé et la qualité de votre relation.</p>
            <p>Pourtant, organiser un séjour adapté relève souvent du parcours du combattant : trouver un hébergement réellement accessible, coordonner les intervenants, organiser le transport adapté, assurer la continuité de l'accompagnement... M-CareLink prend en charge cette coordination pour vous.</p>
          </div>
        </div>

        <h2 className="font-heading text-2xl font-semibold text-foreground mb-6 text-center">Ce que nous vous apportons</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {[
            { icon: Shield, title: "Sérénité", desc: "Un interlocuteur unique gère l'ensemble de la logistique. Vous partez l'esprit tranquille." },
            { icon: Heart, title: "Accompagnement adapté", desc: "Des professionnels qualifiés assurent la continuité de l'assistance pendant votre séjour." },
            { icon: Clock, title: "Gain de temps", desc: "Plus besoin de multiplier les recherches et les appels. Nous coordonnons tout pour vous." },
            { icon: CheckCircle, title: "Accessibilité vérifiée", desc: "Chaque hébergement est évalué sur des critères précis d'accessibilité et de confort." },
            { icon: Users, title: "Activités inclusives", desc: "Des loisirs adaptés pour profiter pleinement de votre séjour ensemble." },
            { icon: Shield, title: "Continuité d'accompagnement", desc: "Nous préparons la transmission des informations nécessaires avec vos professionnels habituels." }
          ].map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-white rounded-2xl p-6 border border-border/30 hover:shadow-md transition-all">
              <Icon className="w-8 h-8 text-accent mb-4" />
              <h3 className="font-heading text-base font-semibold mb-2">{title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/demander-un-sejour">
            <Button className="rounded-full bg-accent text-accent-foreground px-8 py-6 text-lg font-semibold hover:bg-accent/90 shadow-lg hover:scale-105 transition-all" data-testid="caregivers-cta">
              Demander un séjour <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
